import { Component, Input } from '@angular/core';
import { ConfigurationService, LocaleService } from '@ciam/library';
import { DeliveryChannelPreferences } from 'src/app/shared/models/MFAPreferencesResponse';
import { WindowRef } from 'src/app/util/window.ref';

@Component({
  selector: 'wpro-channels-list-item',
  templateUrl: './channels-list-item.component.html',
  standalone: false
})
export class ChannelsListItemComponent {
  @Input() channel: DeliveryChannelPreferences | null | undefined;

  constructor(
    private configService: ConfigurationService,
    private localeService: LocaleService
  ) {}

  termsAndConditionClick($event: any): void {
    let termsAndConditionUrl = `https://${this.configService.select('env.host')}${this.configService.select('links.termsAndConditionsUrl')}`;
    this.localeService.interpolate(termsAndConditionUrl).then((value) => {
      termsAndConditionUrl = value;
      if ($event.target.className.indexOf('termsAndConditions') >= 0) {
        this.openUrl(termsAndConditionUrl);
      }
     });
  }
  openUrl(url: string): void {
    WindowRef.nativeWindow.open(url, '_blank');
  }
}
